import { IProximityProducts } from "api/interfaces/proximity-api.type";
import axios from "../../fetch-api/fetch-api";

export function proximityProductApi(skus: string[]) {
  const params = skus.reduce((queryString: string, cur: string, index) => (`${queryString }sku=${cur}${ index === skus.length - 1 ? "" : "&"}`), "");
  return axios.get<IProximityProducts>(`/get-product-proximity?${params}`, {
  });
}
